import React from "react";

import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { AgentsTableAxios } from "../components/Tables/TechsTable";

function Tecnicos() {
  const { titleTechsString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleTechsString}</title>
      </Helmet>
      <div className="datatable">
        <AgentsTableAxios />
      </div>
    </div>
  );
}

export default Tecnicos;
